import { render, staticRenderFns } from "./SuperuserMenu.vue?vue&type=template&id=725896f6&scoped=true"
import script from "./SuperuserMenu.vue?vue&type=script&lang=js"
export * from "./SuperuserMenu.vue?vue&type=script&lang=js"
import style0 from "./SuperuserMenu.vue?vue&type=style&index=0&id=725896f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725896f6",
  null
  
)

export default component.exports